import dynamic from 'next/dynamic';
import { RfpTrayProps } from './RfpTray.types';

export const RfpTray = dynamic<{ model: RfpTrayProps }>(() => import('./RfpTray').then(mod => mod.RfpTray));
